// ProfileFormList.tsx
import React from 'react';
import { SkeletonBox } from '../../components';




const SettingListLoader: React.FC = () => {
    return <><div className="space-y-12">
        <Section>
            <div className="sm:col-span-6">
            <SkeletonBox height={15}  width={100}/>
            <div className="my-2"></div>
            <SkeletonBox height={35} />
            </div>
            <div className="sm:col-span-6">
            <SkeletonBox height={15}  width={100}/>
            <div className="my-2"></div>
            <SkeletonBox height={35} />
            </div>
            <div className="sm:col-span-6">
            <SkeletonBox height={15}  width={100}/>


                <div className="my-2"></div>
                <SkeletonBox height={35} />
            </div>

        </Section>
    </div></>;
};

interface SectionProps {
    children: React.ReactNode;
}

const Section: React.FC<SectionProps> = ({ children }) => {
    return (
        <div className="space-y-12">
            <div className="grid grid-cols-1 pb-12 border-b gap-x-8 gap-y-10 border-border md:grid-cols-3">
                <div className="ml-10">

                    <h2 className="text-base font-semibold leading-7 text-foreground ">

                        <SkeletonBox height={20} width={100} /></h2>
                        <div className="my-2"></div>

                    <SkeletonBox height={15} width={200} />

                </div>
                <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                    {children}
                </div>
            </div>
        </div>
    );
};


export default SettingListLoader;
